import { mapStory }  from './storyMapper.js'

export class CollectionClient {
  constructor({ url, _get }) {
    this.url = url
    this.get = _get
  }

  help() {
    console.log('getById(id)')
    console.log('getByExhibitId(id)')
  }

  async getById(id) {
    if(!id) return null

    const url = `${this.url}/api/collection/get/${id}`

    const res = await this.get(url, { result: { stories: [], subCollections: [] }})
    const collection = res.result
    collection.stories = collection.stories.map(mapStory)

    return collection
  }

  async getByExhibitId(id) {
    if(!id) return []

    const url = `${this.url}/api/app/collections/get/${id}`

    const res = await this.get(url, { result: [] })

    const collections = res.result
    collections.forEach(collection => {
      collection.stories = collection.stories.map(mapStory)
    })

    return collections
  }
}
